
import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import ShopBadge from './ShopBadge';
import { useShopName } from '../hooks/useShopName';

interface ProductsHeaderProps {
  isAdding?: boolean;
  shopId?: string;
  selectedProducts?: string[];
}

const ProductsHeader = ({ 
  isAdding = false,
  shopId,
  selectedProducts = []
}: ProductsHeaderProps) => {
  const { shopName } = useShopName(shopId);

  if (isAdding) {
    return (
      <div className="shadow-sm border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 rounded-lg p-4">
        <Skeleton className="h-10 w-full" />
      </div>
    );
  }

  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Produits</h1>
        {shopId && shopName && (
          <ShopBadge shopId={shopId} shopName={shopName} />
        )}
      </div>
    </div>
  );
};

export default ProductsHeader;
